"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[41232],{

/***/ 65761:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ uploadAttachmentPreviewStore; },
/* harmony export */   "p": function() { return /* binding */ userProfileStore; }
/* harmony export */ });
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14671);
/* harmony import */ var lib_api_user__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1955);
/* harmony import */ var immer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12902);
/* harmony import */ var stores_chat__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50490);




var uploadAttachmentPreviewStore = (0,zustand__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(function(set) {
    return {
        file: null,
        previewUrl: null,
        type: null,
        meta: null,
        resetFile: function() {
            set({
                file: null,
                previewUrl: null
            });
        },
        setFile: function(file, previewUrl, type) {
            set({
                file: file,
                previewUrl: previewUrl,
                type: type
            });
        },
        setFileMeta: function(orientation) {
            set({
                meta: {
                    orientation: orientation
                }
            });
        }
    };
});
var userProfileStore = (0,zustand__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(function(set) {
    return {
        data: {},
        fetchUserProfile: function(username) {
            return new Promise(function(resolve) {
                stores_chat__WEBPACK_IMPORTED_MODULE_1__/* ["default"].setState */ .Z.setState((0,immer__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(function(state) {
                    state.conversation.isLoading = true;
                }));
                lib_api_user__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getUserProfileGraph */ .Z.getUserProfileGraph(username).then(function(res) {
                    var data = res.data.data;
                    stores_chat__WEBPACK_IMPORTED_MODULE_1__/* ["default"].setState */ .Z.setState((0,immer__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(function(state) {
                        state.conversation.isLoading = false;
                    }));
                    set((0,immer__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(function(state) {
                        state.data[username] = data;
                    }));
                    resolve(data);
                }).catch(function() {
                    stores_chat__WEBPACK_IMPORTED_MODULE_1__/* ["default"].setState */ .Z.setState((0,immer__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(function(state) {
                        state.conversation.isLoading = false;
                    }));
                });
            });
        }
    };
});



/***/ }),

/***/ 26453:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var global_Image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(579);
/* harmony import */ var utils_general__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42227);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48470);




function ReceiverItemAvatar(param) {
    var type = param.type, src = param.src, name = param.name, shortName = param.shortName;
    if (type === "RECEIVER_TYPE_USER") {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_3__/* .AvatarContainer */ .mw, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                alt: name,
                src: src,
                onError: function(e) {
                    return (0,utils_general__WEBPACK_IMPORTED_MODULE_2__/* .handleErrorAvatar */ .Tk)(e, name);
                }
            })
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_3__/* .AvatarContainer */ .mw, {
        children: src === "" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_3__/* .GroupAvatar */ .NS, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                "data-username": name,
                children: shortName
            })
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            alt: name,
            src: src,
            onError: function(e) {
                return (0,utils_general__WEBPACK_IMPORTED_MODULE_2__/* .handleErrorAvatar */ .Tk)(e, name);
            }
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (ReceiverItemAvatar);


/***/ }),

/***/ 41232:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ global_ModalShare; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Iconmoon.js
var Iconmoon = __webpack_require__(15807);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Text.js
var Text = __webpack_require__(95541);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Flex.js
var Flex = __webpack_require__(70821);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
// EXTERNAL MODULE: ./src/utils/general.js
var general = __webpack_require__(42227);
// EXTERNAL MODULE: ./src/lib/entities/chat/slice.ts
var slice = __webpack_require__(10707);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 17 modules
var es = __webpack_require__(2497);
// EXTERNAL MODULE: ./src/global/AlertMessage/index.tsx
var AlertMessage = __webpack_require__(6430);
// EXTERNAL MODULE: ./src/features/stream/analytics/StreamTabAnalytics.ts
var StreamTabAnalytics = __webpack_require__(99093);
// EXTERNAL MODULE: ./src/global/ErrorHandlers/If.js
var If = __webpack_require__(29658);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./src/global/StreamCompose/index.tsx + 25 modules
var StreamCompose = __webpack_require__(76897);
// EXTERNAL MODULE: ./src/utils/stream.js
var stream = __webpack_require__(14601);
// EXTERNAL MODULE: ./src/lib/entities/stream.ts
var entities_stream = __webpack_require__(25641);
// EXTERNAL MODULE: ./src/global/StreamCompose/constants.ts
var constants = __webpack_require__(79030);
// EXTERNAL MODULE: ./src/utils/streamError.ts
var streamError = __webpack_require__(6426);
// EXTERNAL MODULE: ./src/global/StreamWidget/Modals/styled.ts
var styled = __webpack_require__(89784);
;// CONCATENATED MODULE: ./src/global/ModalShare/ModalShareToStockbit.tsx















function ModalShareToStockbit(_param) {
    var post = _param.post, visible = _param.visible, onCancel = _param.onCancel, defaultSharedText = _param.defaultSharedText, props = (0,_object_without_properties/* default */.Z)(_param, [
        "post",
        "visible",
        "onCancel",
        "defaultSharedText"
    ]);
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = (0,es/* useSelector */.v9)(entities_stream/* selectors */.wl), isLoading = ref.shareStream.isLoading;
    var ref1 = (0,react.useState)(null), initialValues = ref1[0], setInitialValues = ref1[1];
    var handleShare = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(val) {
            var data, shareHandling, share, error;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        data = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, val), {
                            postid: post === null || post === void 0 ? void 0 : post.postid,
                            stockbit: 1
                        });
                        shareHandling = defaultSharedText ? entities_stream/* effects.postStream */.Sz.postStream : entities_stream/* effects.shareStream */.Sz.shareStream;
                        _ctx.next = 4;
                        return dispatch(shareHandling(data));
                    case 4:
                        share = _ctx.sent;
                        error = share.payload.error;
                        (0,streamError/* handleErrorPostStream */.R)(error);
                        if (!error) {
                            onCancel();
                        }
                        return _ctx.abrupt("return", error);
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleShare(val) {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        if (defaultSharedText) {
            var defaultValue = (0,stream/* parseStreamPostContent */.vO)({
                content_original: defaultSharedText
            });
            setInitialValues(defaultValue);
        }
    }, [
        defaultSharedText
    ]);
    var shareMode = defaultSharedText ? constants/* COMPOSE_MODE.SHARE_TEXT */.ZX.SHARE_TEXT : constants/* COMPOSE_MODE.REPOST */.ZX.REPOST;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* Modal */.u_, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        visible: visible,
        onCancel: onCancel,
        title: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
            size: "18px",
            height: "44px",
            family: "bold",
            align: "center",
            children: "Share to Stockbit"
        }),
        footer: null,
        centered: true,
        width: 660,
        bodyStyle: {
            padding: "0px"
        },
        children: visible && /*#__PURE__*/ (0,jsx_runtime.jsx)(StreamCompose/* default */.Z, {
            isLoading: isLoading,
            onSubmit: handleShare,
            onCancel: onCancel,
            mode: shareMode,
            initialValues: defaultSharedText ? initialValues : false,
            post: post
        })
    }));
}
/* harmony default export */ var ModalShare_ModalShareToStockbit = (ModalShareToStockbit);

// EXTERNAL MODULE: ./src/global/ModalShare/styled.ts
var ModalShare_styled = __webpack_require__(48470);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/color.js
var color = __webpack_require__(22147);
// EXTERNAL MODULE: ./src/global/ModalShare/SearchReceiver/ReceiverItemAvatar.tsx
var ReceiverItemAvatar = __webpack_require__(26453);
;// CONCATENATED MODULE: ./src/global/ModalShare/SectionItem.tsx








function SectionItem(param) {
    var caption = param.caption, src = param.src, background = param.background, onClick = param.onClick, _selected = param.selected, selected = _selected === void 0 ? false : _selected, bordered = param.bordered, isAvatar = param.isAvatar, data = param.data, imageStyle = param.imageStyle;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        width: "20%",
        direction: "column",
        align: "center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    position: "relative"
                },
                children: [
                    isAvatar ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalShare_styled/* AvatarWrapper */.OR, {
                            role: "button",
                            onClick: onClick,
                            selected: selected,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReceiverItemAvatar/* default */.Z, {
                                name: data === null || data === void 0 ? void 0 : data.name,
                                shortName: data === null || data === void 0 ? void 0 : data.shortName,
                                src: data === null || data === void 0 ? void 0 : data.avatar,
                                type: data.type
                            })
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalShare_styled/* IconMedia */.hu, {
                        background: background,
                        onClick: onClick,
                        // @ts-expect-error
                        selected: selected,
                        bordered: bordered,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                            alt: caption,
                            src: src,
                            style: imageStyle
                        })
                    }),
                    selected && /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalShare_styled/* SelectedIconWrapper */.W3, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconmoon/* default */.Z, {
                            className: "icon-toolbar_check",
                            color: color/* default.light */.Z.light
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                size: "11px",
                ellipsis: true,
                children: caption.length > 11 ? "".concat(caption.slice(0, 11), "...") : caption
            })
        ]
    });
}
/* harmony default export */ var ModalShare_SectionItem = (SectionItem);

;// CONCATENATED MODULE: ./src/global/ModalShare/SectionList.tsx





function SectionList(param) {
    var title = param.title, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalShare_styled/* SectionWrapper */.Uq, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                family: "bold",
                mb: "5px",
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                align: "center",
                children: children
            })
        ]
    });
}
/* harmony default export */ var ModalShare_SectionList = (SectionList);

;// CONCATENATED MODULE: ./src/global/ModalShare/LastConnectedRooms.tsx




function LastConnectedRooms(param) {
    var selectedReceiverId = param.selectedReceiverId, lastConnectedRooms = param.lastConnectedRooms, onSelectReceiver = param.onSelectReceiver, onClickMore = param.onClickMore;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalShare_SectionList, {
        title: "Send to",
        children: [
            lastConnectedRooms.map(function(room) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalShare_SectionItem, {
                    src: room.avatar,
                    caption: room.name,
                    onClick: function() {
                        return onSelectReceiver(room, room.id);
                    },
                    isAvatar: true,
                    selected: selectedReceiverId.includes(room.id),
                    data: room
                }, room.id);
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalShare_SectionItem, {
                background: color/* default.snow */.Z.snow,
                src: "/icon/chevron-right-green.svg",
                caption: "More",
                onClick: onClickMore,
                imageStyle: {
                    width: "auto",
                    height: "auto",
                    minWidth: "20px",
                    minHeight: "20px"
                },
                bordered: true
            })
        ]
    });
}
/* harmony default export */ var ModalShare_LastConnectedRooms = (LastConnectedRooms);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Avatar.js
var Avatar = __webpack_require__(57788);
// EXTERNAL MODULE: ./node_modules/react-visibility-sensor/dist/visibility-sensor.js
var visibility_sensor = __webpack_require__(33082);
var visibility_sensor_default = /*#__PURE__*/__webpack_require__.n(visibility_sensor);
// EXTERNAL MODULE: ./src/constants/data-cy.ts
var data_cy = __webpack_require__(70524);
;// CONCATENATED MODULE: ./src/global/ModalShare/SearchReceiver/ReceiverItem.tsx






function ReceiverItem(param) {
    var receiver = param.receiver, onSelect = param.onSelect, checked = param.checked, disabled = param.disabled;
    return(// @ts-expect-error
    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        width: "100%",
        justify: "space-between",
        align: "center",
        mb: "5px",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                align: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ReceiverItemAvatar/* default */.Z, {
                        name: receiver.name,
                        shortName: receiver.shortName,
                        src: receiver.avatar,
                        type: receiver.type
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        pl: "12px",
                        family: "bold",
                        children: receiver.name
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalShare_styled/* UserCheckbox */.Jy, {
                checked: checked,
                onChange: onSelect,
                disabled: disabled && !checked,
                "data-cy": "".concat(data_cy/* default.SHARE_POST.CHECKBOX */.Z.SHARE_POST.CHECKBOX, "-").concat(receiver.id)
            })
        ]
    }));
}
/* harmony default export */ var SearchReceiver_ReceiverItem = (ReceiverItem);

// EXTERNAL MODULE: ./src/global/ModalShare/utils.ts
var utils = __webpack_require__(77274);
;// CONCATENATED MODULE: ./src/global/ModalShare/SearchReceiver/index.tsx
/* eslint-disable react/no-array-index-key */ 















var TOTAL_ROOM_PER_PAGE = 25;
function SearchReceiver(param) {
    var selectedReceiverId = param.selectedReceiverId, onSelectReceiver = param.onSelectReceiver;
    var ref, ref1;
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref2 = (0,react.useState)(0), timeInterval = ref2[0], setTimeInterval = ref2[1];
    var ref3 = (0,react.useState)(null), selectedReceiver = ref3[0], setSelectedReceiver = ref3[1];
    var ref4 = (0,react.useState)([]), notContactReceivers = ref4[0], setNotContactReceivers = ref4[1];
    var ref5 = (0,react.useState)(false), isLastPage = ref5[0], setIsLastPage = ref5[1];
    var ref6 = (0,react.useState)(""), searchKeyword = ref6[0], setSearchKeyword = ref6[1];
    var ref7 = (0,es/* useSelector */.v9)(slice/* selectors */.wl), roomReceivers = ref7.rooms, _receivers = ref7.receivers, receiverList = _receivers.list, isLoadMoreRooms = ref7.isLoadMoreRooms;
    var combinedReceivers = (0,react.useMemo)(function() {
        return (0,_to_consumable_array/* default */.Z)((0,utils/* transformSearchToReceiverSchema */.G7)(notContactReceivers)).concat((0,_to_consumable_array/* default */.Z)((0,utils/* transformRoomToReceiverSchema */.dT)(roomReceivers)));
    }, [
        roomReceivers,
        notContactReceivers
    ]);
    // Search Receiver
    var handleSearch = function(val) {
        // TODO: set to render last contacted users on clear search
        if (val.length === 0) {
            setSelectedReceiver(null);
            dispatch(slice/* default.actions.resetReceiverList */.ZP.actions.resetReceiverList());
        }
        if (val.length > 0) {
            if (timeInterval) {
                clearTimeout(timeInterval);
            }
            setTimeInterval(setTimeout(function() {
                // @ts-ignore
                dispatch(slice/* effects.getSearchReceivers */.Sz.getSearchReceivers({
                    keyword: val
                }));
            }, 1500));
        }
    };
    // Select autocomplete option
    var handleSelectAutocomplete = function(val) {
        // val value format is id-index-type, we do this
        // because in staging we found multiple user that have same id
        var parsedVal = val.split("-");
        var selected = receiverList.find(function(receiver) {
            return receiver.id === Number(parsedVal[0]);
        });
        setSelectedReceiver(selected);
        // Reset receiver list
        dispatch(slice/* default.actions.resetReceiverList */.ZP.actions.resetReceiverList());
    };
    // Select Receiver Item
    var handleSelectReceiver = function(receiver) {
        onSelectReceiver(receiver, receiver.id);
    };
    // Select search result item
    var handleSelectSearchedReceiver = function(receiver) {
        // check if the receiver available in room list
        var roomIdx = roomReceivers.findIndex(function(room) {
            if (room.type === "ROOM_TYPE_PERSONAL") {
                var ref, ref1;
                return ((ref = room.attributes) === null || ref === void 0 ? void 0 : (ref1 = ref.personal) === null || ref1 === void 0 ? void 0 : ref1.user_id) === receiver.id;
            }
            return room.id === receiver.id;
        });
        // check if the receiver available in notContactReceiver state
        var notContactIdx = notContactReceivers.findIndex(function(room) {
            return room.id === receiver.id;
        });
        if (notContactIdx < 0 && roomIdx < 0) {
            setNotContactReceivers(function(prev) {
                return (0,_to_consumable_array/* default */.Z)(prev).concat([
                    receiver
                ]);
            });
        } else {
            var prevNotContactReceivers = Array.from(notContactReceivers);
            prevNotContactReceivers.splice(notContactIdx, 1);
            setNotContactReceivers(prevNotContactReceivers);
        }
        onSelectReceiver(receiver, receiver.id);
    };
    var handleLoadMoreRooms = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(isVisible) {
            var newOffset, getData, _payload, error, data, ref;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!(isVisible && !isLastPage && !isLoadMoreRooms)) {
                            _ctx.next = 7;
                            break;
                        }
                        newOffset = roomReceivers.length;
                        _ctx.next = 4;
                        return dispatch(slice/* effects.getRooms */.Sz.getRooms({
                            limit: TOTAL_ROOM_PER_PAGE,
                            offset: newOffset,
                            type: "LIST_TYPE_FORWARD"
                        }));
                    case 4:
                        getData = _ctx.sent;
                        _payload = getData.payload, error = _payload.error, data = _payload.data;
                        if (!error) {
                            ;
                            if ((data === null || data === void 0 ? void 0 : (ref = data.rooms) === null || ref === void 0 ? void 0 : ref.length) < TOTAL_ROOM_PER_PAGE) {
                                setIsLastPage(true);
                            }
                        }
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleLoadMoreRooms(isVisible) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleChangeAutocomplete = function(value) {
        setSelectedReceiver(null);
        setSearchKeyword(value);
    };
    var searchValue = (selectedReceiver === null || selectedReceiver === void 0 ? void 0 : (ref = selectedReceiver.info) === null || ref === void 0 ? void 0 : ref.name) || searchKeyword;
    // Search Result Autocomplete Option
    var options = receiverList.map(function(receiver, index) {
        return {
            // keep the value is unique
            value: "".concat(receiver.id, "-").concat(index, "-").concat(receiver.type),
            label: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                align: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                        size: "x-small",
                        mr: "12px",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                            alt: receiver.info.name,
                            src: receiver.info.avatar_url,
                            onError: function(e) {
                                return (0,general/* handleErrorAvatar */.Tk)(e, receiver.info.name);
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                        family: "bold",
                        children: [
                            receiver.info.name,
                            " - ",
                            receiver.info.description
                        ]
                    })
                ]
            }, "".concat(receiver.type, "-").concat(receiver.id, "-").concat(index, "-autocomplete"))
        };
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    position: "relative",
                    marginBottom: "10px"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalShare_styled/* Autocomplete */.F2, {
                    placeholder: "Search",
                    onSearch: handleSearch,
                    onSelect: handleSelectAutocomplete,
                    onChange: handleChangeAutocomplete,
                    options: options,
                    value: searchValue,
                    allowClear: true
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                justify: "space-between",
                width: "100%",
                mb: "5px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        family: "bold",
                        children: "Send to"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                        children: [
                            selectedReceiverId.length,
                            " of 20 selected"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalShare_styled/* SectionWrapper */.Uq, {
                children: selectedReceiver ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchReceiver_ReceiverItem, {
                    receiver: {
                        name: selectedReceiver.info.name,
                        avatar: selectedReceiver.info.avatar_url,
                        id: selectedReceiver.id,
                        shortName: (ref1 = selectedReceiver.info) === null || ref1 === void 0 ? void 0 : ref1.shortened_name,
                        type: selectedReceiver.type
                    },
                    onSelect: function() {
                        return handleSelectSearchedReceiver(selectedReceiver);
                    },
                    checked: selectedReceiverId.includes(selectedReceiver.id),
                    disabled: selectedReceiverId.length >= 20
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        combinedReceivers.map(function(receiver, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchReceiver_ReceiverItem, {
                                receiver: {
                                    name: receiver.name,
                                    avatar: receiver.avatar,
                                    id: receiver.id,
                                    shortName: receiver.shortName,
                                    type: receiver.type
                                },
                                onSelect: function() {
                                    return handleSelectReceiver(receiver);
                                },
                                checked: selectedReceiverId.includes(receiver.id),
                                disabled: selectedReceiverId.length >= 20
                            }, "".concat(receiver.type, "-").concat(receiver.id, "-").concat(index, "-receiver"));
                        }),
                        isLoadMoreRooms && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            align: "center",
                            children: "Loading..."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((visibility_sensor_default()), {
                            onChange: handleLoadMoreRooms,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: "\xa0"
                            })
                        })
                    ]
                })
            })
        ]
    });
}
/* harmony default export */ var ModalShare_SearchReceiver = (SearchReceiver);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./src/hooks/useForm.js
var useForm = __webpack_require__(15077);
;// CONCATENATED MODULE: ./src/global/ModalShare/ShareInput.tsx








function ShareInput(param) {
    var onSubmit = param.onSubmit, defaultMessage = param.defaultMessage, isDisabled = param.isDisabled;
    var ref = (0,_sliced_to_array/* default */.Z)((0,useForm/* default */.Z)({
        initialState: defaultMessage
    }), 2), message = ref[0], setMessage = ref[1];
    var handleSubmit = function() {
        onSubmit(message);
    };
    var buttonIcon = isDisabled ? "/icon/arrow-submit-gray.svg" : "/icon/arrow-submit-green.svg";
    return(// @ts-expect-error
    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        justify: "space-between",
        align: "center",
        pt: "5px",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalShare_styled/* Textarea */.gx, {
                placeholder: "Write a comment...",
                value: message,
                defaultValue: defaultMessage,
                // @ts-ignore
                onChange: setMessage
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalShare_styled/* ButtonSend */.Tc, {
                onClick: handleSubmit,
                disabled: isDisabled,
                "data-cy": data_cy/* default.SHARE_POST.SEND_BUTTON */.Z.SHARE_POST.SEND_BUTTON,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconmoon/* IconWrapper */.a, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                        alt: "Send to chat",
                        src: buttonIcon,
                        style: {
                            width: "21px",
                            height: "21px"
                        }
                    })
                })
            })
        ]
    }));
}
/* harmony default export */ var ModalShare_ShareInput = (ShareInput);

;// CONCATENATED MODULE: ./src/global/ModalShare/SocialMedia.tsx



function SocialMedia(param) {
    var linkUrl = param.linkUrl;
    var handleShareWhatsapp = function() {
        var linkShare;
        if ((0,general/* isMobileVersion */.BF)()) {
            linkShare = "whatsapp://send?text=".concat(linkUrl);
            (0,general/* popupWindowToCenter */.hB)(linkShare, "", 350, 350);
        } else {
            linkShare = "https://api.whatsapp.com/send?text=".concat(encodeURIComponent(linkUrl));
            window.open(linkShare, "_blank");
        }
    };
    var handleShareTelegram = function() {
        var linkShare = "https://telegram.me/share/url?url=".concat(encodeURIComponent(linkUrl));
        if ((0,general/* isMobileVersion */.BF)()) {
            (0,general/* popupWindowToCenter */.hB)(linkShare, "", 350, 350);
        } else {
            window.open(linkShare, "_blank");
        }
    };
    var handleShareTwitter = function() {
        var linkShare = "https://twitter.com/intent/tweet?text=".concat(encodeURIComponent(linkUrl));
        window.open(linkShare, "_blank");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalShare_SectionItem, {
                background: "#25d366",
                onClick: handleShareWhatsapp,
                src: "/images/whatsapp-logo.svg",
                caption: "Whats App",
                imageStyle: {
                    padding: "13px"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalShare_SectionItem, {
                background: "#08c",
                onClick: handleShareTelegram,
                src: "/images/telegram-logo.svg",
                caption: "Telegram",
                imageStyle: {
                    padding: "13px"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalShare_SectionItem, {
                background: "#1b9df0",
                onClick: handleShareTwitter,
                src: "/images/twitter-logo.svg",
                caption: "Twitter",
                imageStyle: {
                    padding: "0px"
                }
            })
        ]
    });
}
/* harmony default export */ var ModalShare_SocialMedia = (SocialMedia);

// EXTERNAL MODULE: ./src/features/chat/MainContent/store.ts
var store = __webpack_require__(65761);
;// CONCATENATED MODULE: ./src/global/ModalShare/SingleRecipient.tsx







function SingleRecipient(param) {
    var selectedReceiverId = param.selectedReceiverId, onSelectReceiver = param.onSelectReceiver, recipientName = param.recipientName, urlToShare = param.message;
    // user profile
    var getRecipient = (0,store/* userProfileStore */.p)(function(store) {
        return store.fetchUserProfile;
    });
    var recipientRecords = (0,store/* userProfileStore */.p)(function(store) {
        return store.data;
    });
    var recipient = recipientRecords[recipientName];
    var data = {
        id: recipient === null || recipient === void 0 ? void 0 : recipient.user_id,
        type: "RECEIVER_TYPE_USER",
        name: recipient === null || recipient === void 0 ? void 0 : recipient.profile.fullname,
        avatar: recipient === null || recipient === void 0 ? void 0 : recipient.profile.avatar_urls.thumbnail_url,
        shortName: recipient === null || recipient === void 0 ? void 0 : recipient.profile.username
    };
    (0,react.useEffect)(function() {
        getRecipient(recipientName);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalShare_SectionList, {
        title: "Share to",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: !!data,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalShare_SectionItem, {
                    src: data.avatar,
                    caption: data.name || "",
                    onClick: function() {
                        return onSelectReceiver(data, data.id);
                    },
                    selected: selectedReceiverId.includes(data.id),
                    data: data,
                    isAvatar: true
                }, data.id)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalShare_SocialMedia, {
                linkUrl: urlToShare
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/global/ModalShare/index.tsx
/* eslint-disable react/jsx-wrap-multilines */ 






















function ModalShare(param) {
    var onCancel = param.onCancel, _sendChat = param.sendChat, sendChat = _sendChat === void 0 ? null : _sendChat, _onCopy = param.onCopy, onCopy = _onCopy === void 0 ? null : _onCopy, visible = param.visible, title = param.title, _post = param.post, post = _post === void 0 ? null : _post, _hasSearchPeople = param.hasSearchPeople, hasSearchPeople = _hasSearchPeople === void 0 ? true : _hasSearchPeople, _hasShareInput = param.hasShareInput, hasShareInput = _hasShareInput === void 0 ? true : _hasShareInput, _hasSocialMedia = param.hasSocialMedia, hasSocialMedia = _hasSocialMedia === void 0 ? false : _hasSocialMedia, _hasRepostButton = param.hasRepostButton, hasRepostButton = _hasRepostButton === void 0 ? false : _hasRepostButton, _hasCopyButton = param.hasCopyButton, hasCopyButton = _hasCopyButton === void 0 ? false : _hasCopyButton, _urlToShare = param.urlToShare, urlToShare = _urlToShare === void 0 ? "" : _urlToShare, _defaultSharedMessage = param.defaultSharedMessage, defaultSharedMessage = _defaultSharedMessage === void 0 ? null : _defaultSharedMessage, _recipientName = param.recipientName, recipientName = _recipientName === void 0 ? null : _recipientName, _hasSingleRecipient = param.hasSingleRecipient, hasSingleRecipient = _hasSingleRecipient === void 0 ? false : _hasSingleRecipient;
    var dispatch = (0,es/* useDispatch */.I0)();
    var rooms = (0,es/* useSelector */.v9)(slice/* selectors */.wl).rooms;
    var lastConnectedRooms = (0,utils/* transformRoomToReceiverSchema */.dT)(rooms.slice(0, 4));
    var ref = (0,react.useState)(false), isSearchReceiver = ref[0], setIsSearchReceiver = ref[1];
    var ref1 = (0,react.useState)(false), showModalRepost = ref1[0], setShowModalRepost = ref1[1];
    // selected searched receivers
    var ref2 = (0,react.useState)([]), selectedReceiver = ref2[0], setSelectedReceiver = ref2[1];
    var ref3 = (0,react.useState)([]), selectedReceiverId = ref3[0], setSelectedReceiverId = ref3[1];
    var showFooter = (hasRepostButton || hasCopyButton) && !isSearchReceiver && selectedReceiver.length === 0;
    var showInput = !showFooter || hasShareInput && selectedReceiver.length > 0;
    var showSocialMedia = hasSocialMedia && selectedReceiver.length === 0 && !isSearchReceiver;
    var showLastConnectedRooms = !isSearchReceiver && hasSearchPeople;
    var handleSelectReceiver = function(receiver, id) {
        var receiverList = Array.from(selectedReceiver);
        var receiverIdList = Array.from(selectedReceiverId);
        var receiverIdx = selectedReceiverId.findIndex(function(i) {
            return i === id;
        });
        if (receiverIdx > -1) {
            receiverList.splice(receiverIdx, 1);
            receiverIdList.splice(receiverIdx, 1);
        } else if (receiverList.length < 20) {
            receiverList.push(receiver);
            receiverIdList.push(id);
        }
        setSelectedReceiver(receiverList);
        setSelectedReceiverId(receiverIdList);
    };
    var handleSendToChat = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(message) {
            var data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (selectedReceiver.length > 0) {
                            data = {
                                receivers: (0,utils/* transformReceiverPayload */.TP)(selectedReceiver),
                                text: message || ""
                            };
                            sendChat(data);
                            setSelectedReceiver([]);
                            setSelectedReceiverId([]);
                        }
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleSendToChat(message) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleShareStockbit = function() {
        setShowModalRepost(true);
        onCancel();
    };
    var handleCopyLink = function() {
        if (onCopy) {
            onCopy();
        } else {
            (0,general/* copyTextToClipboard */.TE)(urlToShare, function() {
                return (0,AlertMessage/* default */.Z)({
                    content: "Link Copied",
                    alertType: "snackbar",
                    messageType: "success",
                    hasCloseIcon: true
                });
            });
        }
    };
    var handleClickMoreContact = function() {
        setIsSearchReceiver(true);
        StreamTabAnalytics/* default.common.Action.clickMoreShare */.ZP.common.Action.clickMoreShare();
    };
    var refreshRooms = function() {
        dispatch(slice/* effects.getRooms */.Sz.getRooms({
            limit: 25,
            offset: 0,
            type: "LIST_TYPE_FORWARD"
        }));
    };
    (0,react.useEffect)(function() {
        if (!visible) {
            setIsSearchReceiver(false);
            setSelectedReceiver([]);
            setSelectedReceiverId([]);
        }
    }, [
        visible
    ]);
    (0,react.useEffect)(function() {
        if (visible && lastConnectedRooms.length === 0) {
            refreshRooms();
            setSelectedReceiver([]);
            setSelectedReceiverId([]);
        }
    }, [
        visible
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalShare_styled/* Modal */.u_, {
                visible: visible,
                onCancel: onCancel,
                centered: true,
                footer: null,
                title: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    size: "18px",
                    family: "bold",
                    align: "center",
                    children: title
                }),
                width: 430,
                // @ts-expect-error
                id: "modal-share",
                transitionName: "",
                maskTransitionName: "",
                destroyOnClose: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                        condition: hasSingleRecipient,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SingleRecipient, {
                            message: defaultSharedMessage,
                            selectedReceiverId: selectedReceiverId,
                            onSelectReceiver: handleSelectReceiver,
                            recipientName: recipientName
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                        condition: !hasSingleRecipient && showLastConnectedRooms,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalShare_LastConnectedRooms, {
                            selectedReceiverId: selectedReceiverId,
                            lastConnectedRooms: lastConnectedRooms,
                            onSelectReceiver: handleSelectReceiver,
                            onClickMore: handleClickMoreContact
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                        condition: !showLastConnectedRooms,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalShare_SearchReceiver, {
                            selectedReceiverId: selectedReceiverId,
                            onSelectReceiver: handleSelectReceiver
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                        condition: showSocialMedia,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalShare_SectionList, {
                            title: "Share to",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalShare_SocialMedia, {
                                linkUrl: urlToShare
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                        condition: showInput,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalShare_ShareInput, {
                            onSubmit: handleSendToChat,
                            defaultMessage: defaultSharedMessage,
                            isDisabled: selectedReceiver.length === 0
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                        condition: showFooter,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                            width: "100%",
                            justify: "space-between",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                    condition: hasCopyButton,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalShare_styled/* ButtonAction */.Wc, {
                                        onClick: handleCopyLink,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconmoon/* IconWrapper */.a, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                                    src: "/icon/copy-link.svg",
                                                    alt: "Copy link",
                                                    style: {
                                                        height: "14px",
                                                        minHeight: "14px",
                                                        minWidth: "14px",
                                                        marginRight: "10px"
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                family: "bold",
                                                children: "Copy Link"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                    condition: hasRepostButton,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalShare_styled/* ButtonAction */.Wc, {
                                        onClick: handleShareStockbit,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconmoon/* IconWrapper */.a, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                                    src: "/icon/repost-stream.svg",
                                                    alt: "Copy link",
                                                    style: {
                                                        height: "14px",
                                                        minHeight: "14px",
                                                        minWidth: "14px",
                                                        marginRight: "10px"
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                family: "bold",
                                                children: "Repost"
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalShare_ModalShareToStockbit, {
                post: post,
                defaultSharedText: defaultSharedMessage,
                visible: showModalRepost,
                destroyOnClose: true,
                onCancel: function() {
                    return setShowModalRepost(false);
                }
            })
        ]
    });
}
/* harmony default export */ var global_ModalShare = (ModalShare);


/***/ }),

/***/ 48470:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F2": function() { return /* binding */ Autocomplete; },
/* harmony export */   "Jy": function() { return /* binding */ UserCheckbox; },
/* harmony export */   "NS": function() { return /* binding */ GroupAvatar; },
/* harmony export */   "OR": function() { return /* binding */ AvatarWrapper; },
/* harmony export */   "Tc": function() { return /* binding */ ButtonSend; },
/* harmony export */   "Uq": function() { return /* binding */ SectionWrapper; },
/* harmony export */   "W3": function() { return /* binding */ SelectedIconWrapper; },
/* harmony export */   "Wc": function() { return /* binding */ ButtonAction; },
/* harmony export */   "gx": function() { return /* binding */ Textarea; },
/* harmony export */   "hu": function() { return /* binding */ IconMedia; },
/* harmony export */   "mw": function() { return /* binding */ AvatarContainer; },
/* harmony export */   "u_": function() { return /* binding */ Modal; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(19521);
/* harmony import */ var _deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70821);
/* harmony import */ var _deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20539);
/* harmony import */ var _deprecated_ui_common_Iconmoon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15807);
/* harmony import */ var _deprecated_ui_common_Avatar__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57788);
/* harmony import */ var _deprecated_ui_common_Checkbox__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(81190);
/* harmony import */ var _deprecated_ui_common_Modal__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(16368);
/* harmony import */ var _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(22147);
/* harmony import */ var global_SearchAutocomplete__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(40737);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(7648);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-modal-content {\n    border-radius: 3px;\n  }\n  .ant-modal-header {\n    border-color: ",
        ";\n    border-radius: 3px 3px 0 0;\n    height: 66px;\n    padding: 0 20px !important;\n\n    .ant-modal-title {\n      padding: 22px 0;\n      border-bottom: solid 1px ",
        ";\n    }\n  }\n  .ant-modal-body {\n    padding: 20px;\n    border-radius: 0 0 3px 3px;\n  }\n  .ant-modal-footer {\n    padding: 0 !important;\n    text-align: left;\n    display: flex;\n  }\n  .ant-modal-close {\n    top: 14px;\n    right: 14px;\n\n    .ant-modal-close-x {\n      width: 40px;\n      height: 40px;\n      line-height: 40px;\n      font-size: 18px;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      border: solid 1px ",
        ";\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background-color: ",
        ";\n  border-radius: 50%;\n  width: 50px;\n  height: 50px;\n  margin-bottom: 5px;\n  cursor: pointer;\n\n  ",
        "\n\n  img {\n    background: none;\n    padding: 10px;\n    width: 100%;\n    height: 100%;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background: ",
        ";\n  border: solid 0.5px ",
        ";\n  border-radius: 7px;\n  cursor: pointer;\n  height: 40px;\n  position: relative;\n  width: 100%;\n\n  &:hover,\n  &:active,\n  &:focus {\n    background: ",
        ";\n    border-color: ",
        ";\n  }\n\n  &:first-child {\n    margin-right: 14px;\n  }\n\n  &:last-child {\n    margin-left: 14px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-bottom: solid 0.5px ",
        ";\n  margin-bottom: 15px;\n  max-height: 200px;\n  overflow-y: auto;\n  padding-bottom: 15px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      border-color: ",
        ";\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border: solid 1px;\n  border-color: transparent;\n  border-radius: 50%;\n  cursor: pointer;\n  margin-bottom: 5px;\n\n  ",
        "\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background: ",
        ";\n  border-radius: 50%;\n  bottom: 5px;\n  position: absolute;\n  right: 2px;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-bottom: 20px;\n\n  .ant-input-affix-wrapper {\n    border-color: ",
        ";\n    border-radius: 5px;\n    height: 45px;\n    background-color: ",
        ";\n\n    input {\n      background-color: ",
        ";\n      padding-left: 5px;\n    }\n\n    input::placeholder {\n      font-family: var(--font-bold);\n      color: #c4c4c4;\n    }\n\n    :hover {\n      border: unset;\n    }\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-checkbox {\n    .ant-checkbox-inner {\n      border-radius: 50%;\n      height: 25px;\n      width: 25px;\n\n      &::after {\n        height: 11.142857px;\n        left: 25%;\n        width: 7.714286px;\n      }\n    }\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background-color: ",
        ";\n  border-color: ",
        ";\n  border-radius: 12px;\n  font-family: 'ProximaNovaRg';\n  line-height: 1.4;\n  resize: none;\n  width: 85%;\n\n  &.ant-input {\n    height: 40px;\n    min-height: 40px;\n  }\n\n  ::placeholder {\n    font-family: var(--font-bold);\n  }\n\n  :hover,\n  :focus {\n    border-color: ",
        ";\n    box-shadow: none;\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background: none;\n  border: none;\n  cursor: pointer;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 50px;\n  height: 50px;\n  line-height: 50px;\n  display: block;\n  font-size: 16px;\n  font-weight: 700;\n  text-transform: uppercase;\n  text-align: center;\n  border-radius: 100%;\n  overflow: hidden;\n  background: #ebf8f3;\n  color: #00ab6b;\n  i {\n    font-style: normal;\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  & > img {\n    border-radius: 50%;\n    width: 50px;\n    height: 50px;\n    border: 1px solid ",
        ";\n    background: ",
        ";\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}










var TextArea = antd__WEBPACK_IMPORTED_MODULE_9__/* ["default"].TextArea */ .Z.TextArea;
var Modal = (0,styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP)(_deprecated_ui_common_Modal__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z).withConfig({
    componentId: "sc-7f25c831-0"
})(_templateObject(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].gainsboro */ .Z.gainsboro, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].gainsboro */ .Z.gainsboro);
var IconMedia = (0,styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).attrs(function(props) {
    return {
        // @ts-expect-error
        background: props.background || "none",
        align: "center",
        justify: "center"
    };
}).withConfig({
    componentId: "sc-7f25c831-1"
})(_templateObject2(), function(props) {
    return props.background;
}, // @ts-expect-error
function(param) {
    var bordered = param.bordered;
    return bordered && (0,styled_components__WEBPACK_IMPORTED_MODULE_10__/* .css */ .iv)(_templateObject1(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].gainsboro */ .Z.gainsboro);
});
var ButtonAction = (0,styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP)(_deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-7f25c831-2"
})(_templateObject3(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].snow */ .Z.snow, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].gainsboro */ .Z.gainsboro, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].snow */ .Z.snow, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].gainsboro */ .Z.gainsboro);
var SectionWrapper = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].section.withConfig */ .ZP.section.withConfig({
    componentId: "sc-7f25c831-3"
})(_templateObject4(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].gainsboro */ .Z.gainsboro);
var AvatarWrapper = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-7f25c831-4"
})(_templateObject6(), function(param) {
    var selected = param.selected;
    return selected && (0,styled_components__WEBPACK_IMPORTED_MODULE_10__/* .css */ .iv)(_templateObject5(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].primary */ .Z.primary);
});
var SelectedIconWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP)(_deprecated_ui_common_Iconmoon__WEBPACK_IMPORTED_MODULE_3__/* .IconWrapper */ .a).withConfig({
    componentId: "sc-7f25c831-5"
})(_templateObject7(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].primary */ .Z.primary);
var Autocomplete = (0,styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP)(global_SearchAutocomplete__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z).withConfig({
    componentId: "sc-7f25c831-6"
})(_templateObject8(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].snow */ .Z.snow, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].snow */ .Z.snow, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].snow */ .Z.snow);
var UserCheckbox = (0,styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP)(_deprecated_ui_common_Checkbox__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).attrs({
    checkboxType: "primary"
}).withConfig({
    componentId: "sc-7f25c831-7"
})(_templateObject9());
var Textarea = (0,styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP)(TextArea).withConfig({
    componentId: "sc-7f25c831-8"
})(_templateObject10(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].snow */ .Z.snow, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].gainsboro */ .Z.gainsboro, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].gainsboro */ .Z.gainsboro);
var ButtonSend = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    componentId: "sc-7f25c831-9"
})(_templateObject11());
var GroupAvatar = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-7f25c831-10"
})(_templateObject12());
var AvatarContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP)(_deprecated_ui_common_Avatar__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).withConfig({
    componentId: "sc-7f25c831-11"
})(_templateObject13(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].component */ .Z.component, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].lowgray */ .Z.lowgray);
// eslint-disable-next-line import/prefer-default-export



/***/ }),

/***/ 77274:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G7": function() { return /* binding */ transformSearchToReceiverSchema; },
/* harmony export */   "TP": function() { return /* binding */ transformReceiverPayload; },
/* harmony export */   "dT": function() { return /* binding */ transformRoomToReceiverSchema; }
/* harmony export */ });
/* eslint-disable import/prefer-default-export */ var transformReceiverType = function(type) {
    if (type === "ROOM_TYPE_PERSONAL") {
        return "RECEIVER_TYPE_USER";
    }
    if (type === "ROOM_TYPE_GROUP") {
        return "RECEIVER_TYPE_ROOM";
    }
    return "RECEIVER_TYPE_UNSPECIFIED";
};
var transformRoomToReceiverSchema = function(rooms) {
    return rooms.map(function(room) {
        var ref, ref1, ref2;
        return {
            id: room.type === "ROOM_TYPE_PERSONAL" ? (ref = room.attributes) === null || ref === void 0 ? void 0 : (ref1 = ref.personal) === null || ref1 === void 0 ? void 0 : ref1.user_id : room.id,
            type: transformReceiverType(room.type),
            name: room.info.name,
            avatar: room.info.avatar_url,
            shortName: (ref2 = room.info) === null || ref2 === void 0 ? void 0 : ref2.shortened_name
        };
    });
};
var transformSearchToReceiverSchema = function(result) {
    return result.map(function(item) {
        var ref;
        return {
            id: item.id,
            type: item.type,
            name: item.info.name,
            avatar: item.info.avatar_url,
            shortName: (ref = item.info) === null || ref === void 0 ? void 0 : ref.shortened_name
        };
    });
};
var transformReceiverPayload = function(receivers) {
    return receivers.map(function(param) {
        var id = param.id, type = param.type;
        return {
            id: id,
            type: type
        };
    });
};



/***/ }),

/***/ 40737:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _deprecated_ui_common_Iconmoon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15807);
/* harmony import */ var _deprecated_ui_common_Autocomplete__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94526);
/* harmony import */ var _deprecated_ui_common_Input__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54325);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* eslint-disable @typescript-eslint/no-empty-function */ 







var DEFAULT_WIDTH = "100%";
var DEFAULT_HEIGHT = "36px";
var DEFAULT_PLACEHOLDER = "Type here to search...";
/**
 * Search autocomplete
 * @param {Object} props
 * @param {function} props.onSearch
 * @param {function} props.onSelect
 * @param {function=} props.onChange
 * @param {Array<any>} props.options
 * @param {string=} props.width
 * @param {string=} props.height
 * @param {string=} props.placeholder
 * @param {React.ReactNode=} props.prefix
 * @param {React.ReactNode=} props.suffix
 * @param {boolean=} props.allowClear
 * @param {string=} props.value
 * @param {boolean=} props.open
 */ function SearchAutocomplete(_param) {
    var onSearch = _param.onSearch, onSelect = _param.onSelect, options = _param.options, width = _param.width, height = _param.height, placeholder = _param.placeholder, prefix = _param.prefix, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "onSearch",
        "onSelect",
        "options",
        "width",
        "height",
        "placeholder",
        "prefix"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Autocomplete__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        "data-testid": "search-autocomplete",
        options: options,
        width: width,
        onSearch: onSearch,
        onSelect: onSelect
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Input__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            prefix: prefix,
            width: "100%",
            height: height,
            placeholder: placeholder
        })
    }));
}
SearchAutocomplete.propTypes = {
    options: prop_types__WEBPACK_IMPORTED_MODULE_4___default().oneOfType([
        (prop_types__WEBPACK_IMPORTED_MODULE_4___default().array),
        (prop_types__WEBPACK_IMPORTED_MODULE_4___default().any)
    ]),
    width: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    height: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    placeholder: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    onSearch: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().func),
    onSelect: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().func),
    prefix: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().node)
};
SearchAutocomplete.defaultProps = {
    options: [],
    width: DEFAULT_WIDTH,
    height: DEFAULT_HEIGHT,
    placeholder: DEFAULT_PLACEHOLDER,
    onSearch: function() {},
    onSelect: function() {},
    prefix: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Iconmoon__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        className: "icon-avatar_search"
    })
};
/* harmony default export */ __webpack_exports__["Z"] = (SearchAutocomplete);


/***/ }),

/***/ 89784:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Aq": function() { return /* binding */ SModalInsight; },
/* harmony export */   "B9": function() { return /* binding */ ButtonSendTipping; },
/* harmony export */   "EL": function() { return /* binding */ AnnouncementAttachmentLabel; },
/* harmony export */   "Id": function() { return /* binding */ InsightWrapper; },
/* harmony export */   "Ih": function() { return /* binding */ AnnouncementCompanyCard; },
/* harmony export */   "Is": function() { return /* binding */ ButtonTipping; },
/* harmony export */   "J5": function() { return /* binding */ AnnouncementCompanyCardIcon; },
/* harmony export */   "KP": function() { return /* binding */ AnnouncementLoading; },
/* harmony export */   "Kx": function() { return /* binding */ TextArea; },
/* harmony export */   "N1": function() { return /* binding */ TextareaTippingMessage; },
/* harmony export */   "Ph": function() { return /* binding */ Select; },
/* harmony export */   "SV": function() { return /* binding */ PostInsightFreeze; },
/* harmony export */   "Wx": function() { return /* binding */ Option; },
/* harmony export */   "YZ": function() { return /* binding */ SymbolErrorIcon; },
/* harmony export */   "bM": function() { return /* binding */ InputAmountTipping; },
/* harmony export */   "fU": function() { return /* binding */ AttachmentList; },
/* harmony export */   "hS": function() { return /* binding */ PostInsightContainer; },
/* harmony export */   "re": function() { return /* binding */ InsightContainer; },
/* harmony export */   "sD": function() { return /* binding */ TippingWrapper; },
/* harmony export */   "u_": function() { return /* binding */ Modal; },
/* harmony export */   "wx": function() { return /* binding */ SModalReport; },
/* harmony export */   "zx": function() { return /* binding */ Button; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70821);
/* harmony import */ var _deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95541);
/* harmony import */ var _deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20539);
/* harmony import */ var _deprecated_ui_common_Input__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(54325);
/* harmony import */ var _deprecated_ui_common_Modal__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(16368);
/* harmony import */ var _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(22147);
/* harmony import */ var _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(74575);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(19521);
/* harmony import */ var react_number_format__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(57333);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-modal-content {\n    border-radius: 3px !important;\n  }\n  .ant-modal-header {\n    padding: 0 20px !important;\n    height: 40px;\n    border-color: ",
        ";\n    border-radius: 3px !important;\n  }\n  .ant-modal-body {\n    padding: 20px;\n  }\n  .ant-modal-footer {\n    padding: 0 !important;\n    text-align: left;\n    display: flex;\n  }\n  .ant-modal-close-x {\n    width: 40px;\n    height: 40px;\n    line-height: 40px;\n    font-size: 12px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 8px;\n  line-height: 14px;\n  width: 100%;\n  border-radius: 3px;\n  font-size: 14px;\n  margin: 5px 0;\n  border: 1px solid ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin: 5px 0;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  @media ",
        " {\n    padding: 0 12px 14px 12px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-left: 0px !important;\n  border-radius: 0px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      background: ",
        ";\n      border: 1px solid ",
        ";\n      color: ",
        ";\n    "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 12px;\n  font-family: ProximaNovaRg;\n  min-width: 70px;\n  border-radius: 3px;\n  padding: 6px 12px;\n  border: 1px solid ",
        ";\n  background: ",
        ";\n\n  ",
        "\n\n  @media ",
        " {\n    min-width: 100px;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-radius: 3px;\n  padding: 10px 18px;\n  line-height: 16.1px;\n  border: 1px solid ",
        ";\n\n  &.bold-input {\n    font-family: var(--bold-font);\n\n    ::placeholder {\n      font-family: var(--regular-font);\n      color: ",
        ";\n    }\n  }\n\n  &.ash-input {\n    background-color: #f7f7f7;\n  }\n\n  ::placeholder {\n    font-family: var(--font-bold);\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-radius: 3px;\n  max-height: 62px;\n  border: 1px solid ",
        ";\n  padding: 10px 18px;\n  resize: none;\n\n  ::placeholder {\n    font-family: var(--font-bold);\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-radius: 3px;\n  :disabled {\n    background: #cceee1;\n    border: none;\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-modal-header {\n    border-radius: 3px 3px 0 0 !important;\n    border-bottom: 1px solid ",
        ";\n  }\n\n  .ant-modal-footer {\n    button:first-child {\n      border-radius: 0 0 0 3px;\n    }\n    button:last-child {\n      border-radius: 0 0 3px 0;\n    }\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-modal-body {\n    padding: 30px !important;\n    max-height: 500px;\n    overflow: scroll;\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  #insight-detail {\n    margin-bottom: 20px;\n    width: 100%;\n    border-left: unset;\n  }\n  #post-detail {\n    width: 100%;\n    border-right: unset;\n  }\n  @media ",
        " {\n    flex-direction: row;\n    #insight-detail {\n      margin-bottom: unset;\n      padding-left: 20px;\n      width: 50%;\n      border-left: 1px solid #dadada;\n    }\n    #post-detail {\n      width: 50%;\n      padding-right: 20px;\n      border-right: 1px solid #dadada;\n    }\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background: 0 0;\n  z-index: 1;\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 50%;\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-radius: 4px;\n  border: 1px solid ",
        ";\n  gap: 16px;\n  padding: 11px 15px;\n  margin-bottom: 24px;\n  cursor: pointer;\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 54px;\n  height: 54px;\n  border-radius: 50%;\n  background: ",
        ";\n  justify-content: center;\n\n  img {\n    border-radius: 50%;\n    width: 54px;\n    height: 54px;\n  }\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding-bottom: 12px;\n  margin-bottom: 16px;\n  border-bottom: 1px solid #f1f1f1;\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  border-radius: 50%;\n  img {\n    animation: ",
        " 1s infinite linear;\n  }\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  list-style-type: none;\n  padding-left: 0px;\n  margin-bottom: 0px;\n  li {\n    border-bottom: 1px solid #f1f1f1;\n  }\n  li:last-child {\n    border-bottom: unset !important;\n  }\n\n  li > a > div > p {\n    word-break: break-all;\n    padding-right: 0;\n  }\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background: #3a645c;\n  color: ",
        ";\n  font-size: 20px;\n  width: 54px;\n  height: 54px;\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}









var Modal = (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP)(_deprecated_ui_common_Modal__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).attrs({
    zIndex: 1031,
    transitionName: "",
    maskTransitionName: ""
}).withConfig({
    componentId: "sc-dcfdc389-0"
})(_templateObject(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].gainsboro */ .Z.gainsboro);
var Select = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].select.withConfig */ .ZP.select.withConfig({
    componentId: "sc-dcfdc389-1"
})(_templateObject1(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].gainsboro */ .Z.gainsboro);
var Option = (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).attrs({
    as: "option"
}).withConfig({
    componentId: "sc-dcfdc389-2"
})(_templateObject2());
var TextArea = (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP)(_deprecated_ui_common_Input__WEBPACK_IMPORTED_MODULE_4__/* ["default"].TextArea */ .Z.TextArea).withConfig({
    componentId: "sc-dcfdc389-3"
})(_templateObject3());
var TippingWrapper = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-dcfdc389-4"
})(_templateObject4(), _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_7__/* ["default"].tablet */ .Z.tablet);
var Button = (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP)(_deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-dcfdc389-5"
})(_templateObject5());
var ButtonTipping = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    componentId: "sc-dcfdc389-6"
})(_templateObject7(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].whisper */ .Z.whisper, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].light */ .Z.light, function(param) {
    var isSelected = param.isSelected;
    return isSelected && (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* .css */ .iv)(_templateObject6(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].mintCream */ .Z.mintCream, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].primary */ .Z.primary, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].primary */ .Z.primary);
}, _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_7__/* ["default"].mobileL */ .Z.mobileL);
var InputAmountTipping = (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP)(react_number_format__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z).withConfig({
    componentId: "sc-dcfdc389-7"
})(_templateObject8(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].whisper */ .Z.whisper, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].whisper */ .Z.whisper, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].whisper */ .Z.whisper);
var TextareaTippingMessage = (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP)(_deprecated_ui_common_Input__WEBPACK_IMPORTED_MODULE_4__/* ["default"].TextArea */ .Z.TextArea).withConfig({
    componentId: "sc-dcfdc389-8"
})(_templateObject9(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].whisper */ .Z.whisper, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].whisper */ .Z.whisper);
var ButtonSendTipping = (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP)(_deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-dcfdc389-9"
})(_templateObject10());
var SModalReport = (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP)(Modal).withConfig({
    componentId: "sc-dcfdc389-10"
})(_templateObject11(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].gainsboro */ .Z.gainsboro);
var SModalInsight = (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP)(Modal).withConfig({
    componentId: "sc-dcfdc389-11"
})(_templateObject12());
var InsightWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).attrs({
    direction: "column-reverse"
}).withConfig({
    componentId: "sc-dcfdc389-12"
})(_templateObject13(), _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_7__/* ["default"].tablet */ .Z.tablet);
var PostInsightContainer = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-dcfdc389-13"
})(_templateObject14());
var PostInsightFreeze = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-dcfdc389-14"
})(_templateObject15());
var InsightContainer = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-dcfdc389-15"
})(_templateObject16());
var AnnouncementCompanyCard = (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).attrs({
    align: "center"
}).withConfig({
    componentId: "sc-dcfdc389-16"
})(_templateObject17(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].downgray */ .Z.downgray);
var AnnouncementCompanyCardIcon = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-dcfdc389-17"
})(_templateObject18(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].downgray */ .Z.downgray);
var AnnouncementAttachmentLabel = (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-dcfdc389-18"
})(_templateObject19());
var loadingAnimation = (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* .keyframes */ .F4)(_templateObject20());
var AnnouncementLoading = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-dcfdc389-19"
})(_templateObject21(), loadingAnimation);
var AttachmentList = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].ul.withConfig */ .ZP.ul.withConfig({
    componentId: "sc-dcfdc389-20"
})(_templateObject22());
var SymbolErrorIcon = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-dcfdc389-21"
})(_templateObject23(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].light */ .Z.light);



/***/ })

}]);